import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import Cookies from "js-cookie";

NProgress.configure({ showSpinner: false })

const whiteList = [
  '/index',
  '/login',
  '/auth-redirect',
  '/bind',
  '/attestationDetail',
  '/applicationForm',
  '/applicationList',
  '/certificateList',
  '/certificateSee',
  '/informationList',
  '/circulationList',
  '/circulationAdd',
  '/homesteadLogin',
]

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      // if (store.getters.roles.length === 0) {
      //   next()
      //   // 判断当前用户是否已拉取完user_info信息
      //   store.dispatch('GetInfo').then(res => {
      //     // 拉取user_info
      //     const roles = res.roles
      //     // store.dispatch('GenerateRoutes', { roles }).then(accessRoutes => {
      //     //   // 根据roles权限生成可访问的路由表
      //     //   router.addRoutes(accessRoutes) // 动态添加可访问路由表
      //     //   next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
      //     // })
      //     next()
      //   }).catch(err => {
      //     store.dispatch('LogOut').then(() => {
      //       try {
      //         let loginUrl = Cookies.get("_Login_url");
      //         if(loginUrl && loginUrl.indexOf("homesteadLogin") !== -1)
      //         {
      //           next({ path: '/homesteadLogin' })
      //           return;
      //         }
      //       } catch (e) { console.log(e); }
      //       if (to.path.indexOf('/homesteadSurvey') !== -1) {
      //         next(`/homesteadLogin`)
      //       } else if (to.path.indexOf('/homesteadSurvey') !== -1) {
      //         next(`/homesteadLogin`)
      //       } else {
      //         next(`/homesteadLogin`)
      //         //next({ path: '/' })
      //       }
      //     })
      //   })
      // } else {
      //   next()
      // }
      next()
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      console.log(to.path)
      next()
    } else {
      try {
        let loginUrl = Cookies.get("_Login_url");
        if(loginUrl && loginUrl.indexOf("homesteadLogin") !== -1)
        {
          next({ path: `/homesteadLogin?redirect=${to.fullPath}` })
          return;
        }
      } catch (e) { console.log(e); }
      if (to.path.indexOf('/homesteadSurvey') !== -1) {
        next(`/homesteadLogin`)
      } else if (to.path.indexOf('/homesteadSurvey') !== -1) {
        next(`/homesteadLogin`)
      } else {
        next(`/homesteadLogin`)
        //next(`/login?redirect=${to.fullPath}`)
      }

      //  // 否则全部重定向到登录页
      //next('/index');
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js